module.exports = __webpack_public_path__ + "static/media/dev.1a602c16.svg";